export default {
  title: 'Datos del comprador'
}
